/* eslint-disable arrow-body-style */
/* eslint-disable consistent-return */
/* eslint-disable no-use-before-define */
import React, { useState, createContext, useMemo, useEffect } from "react";
import { PRE_LINK, STEPS } from "../vars";
import { checkSessionTime, getCurrentTimeInSeconds } from "../utils/util";
import useGetParams from "../customHook/useGetParams";

export const UserDetailsContext = createContext();
function UserDetailsProvider({ children }) {
	const [gender, setGender] = useState("");
	const [linkType] = useState(PRE_LINK);
	const [scanStartTime, setScanStartTime] = useState(getCurrentTimeInSeconds());
	const [steps, setSteps] = useState(STEPS.EMAIL);
	const [shopifyRedirectUrl, setShopifyRedirectUrl] = useState();
	const [shopDomain, setShopDomain] = useState();
	const [mobileUrl, setMobileUrl] = useState("");
	const [scanType, setScanType] = useState();
	const [email, setEmail] = useState("");
	const [name, setName] = useState("");
	const [userInfo, setUserInfo] = useState({
		privacyPolicy: true,
		height: {
			cm: "",
			ft: "",
			inch: "",
		},
		device: {
			brandName: "",
			modelName: "",
			focalLength: "",
		},
	});
	useGetParams({
		setShopDomain,
		setScanType,
		setEmail,
		setShopifyRedirectUrl,
		setMobileUrl,
		setName,
		setUserInfo,
		setGender,
	});

	useEffect(() => {
		if (shopDomain) {
			checkSessionTime(email, shopDomain);
		}
	}, [email, shopDomain]);

	const userDetails = useMemo(
		() => ({
			gender,
			linkType,
			setGender,
			shopifyRedirectUrl,
			setShopifyRedirectUrl,
			userInfo,
			setUserInfo,
			mobileUrl,
			setMobileUrl,
			shopDomain,
			email,
			setEmail,
			scanType,
			setScanType,
			scanStartTime,
			setScanStartTime,
			steps,
			setSteps,
			setName,
			name,
			setShopDomain,
		}),
		[gender, linkType, shopifyRedirectUrl, userInfo, mobileUrl, shopDomain, email, scanStartTime, steps, scanType, name],
	);

	return <UserDetailsContext.Provider value={userDetails}>{children}</UserDetailsContext.Provider>;
}
export default UserDetailsProvider;
